export function getEnv(name) {
  if (process.env.NODE_ENV === "production") {
    return window.envVars[name];
  }
  return process.env[name];
}
